// Function to store user ID in service worker
/* export function storeUserIdInServiceWorker(userId) {
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage({
      type: 'STORE_USER_ID',
      userId: userId
    });
  }
} */

// Function to update user ID in service worker
export function updateUserInServiceWorker(userId) {
  console.log('🔄 Attempting to update user in service worker:', userId);
  
  if ('serviceWorker' in navigator) {
    if (navigator.serviceWorker.controller) {
      console.log('✅ Service worker controller found, sending message');
      navigator.serviceWorker.controller.postMessage({
        type: 'UPDATE_USER_ID',
        userId: userId
      });
    } else {
      console.log('❌ No service worker controller found');
      // Wait for service worker to be ready
      navigator.serviceWorker.ready.then(registration => {
        console.log('✅ Service worker ready, sending message');
        if (registration.active) {
          registration.active.postMessage({
            type: 'UPDATE_USER_ID',
            userId: userId
          });
        }
      });
    }
  } else {
    console.log('❌ Service worker not supported');
  }
}

// Function to clear user ID from service worker
export function clearUserFromServiceWorker() {
  console.log('🗑️ Attempting to clear user from service worker');
  
  if ('serviceWorker' in navigator) {
    if (navigator.serviceWorker.controller) {
      console.log('✅ Service worker controller found, sending clear message');
      navigator.serviceWorker.controller.postMessage({
        type: 'CLEAR_USER_ID'
      });
    } else {
      console.log('❌ No service worker controller found');
      // Wait for service worker to be ready
      navigator.serviceWorker.ready.then(registration => {
        console.log('✅ Service worker ready, sending clear message');
        if (registration.active) {
          registration.active.postMessage({
            type: 'CLEAR_USER_ID'
          });
        }
      });
    }
  } else {
    console.log('❌ Service worker not supported');
  }
}



// Function to handle service worker messages (call this once in your app)
export function setupServiceWorkerMessageListener() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', function(event) {
      if (event.data && event.data.type === 'GET_USER_ID') {
        // Get user ID from your app's state/storage
        const userId = localStorage.getItem('userId') || 
                       sessionStorage.getItem('userId') ||
                       localStorage.getItem('customerId') || 
                       sessionStorage.getItem('customerId') ||
                       localStorage.getItem('vendorId') || 
                       sessionStorage.getItem('vendorId');
        
        // Send back to service worker
        event.ports[0].postMessage({ userId: userId });
      }
    });
  }
}

/* // Function to call when user logs in
export function onUserLogin(userId) {
  // Store in your usual storage
  localStorage.setItem('userId', userId);
  
  // Also store in service worker
  storeUserIdInServiceWorker(userId);
}

// Function to call when user logs out
export function onUserLogout() {
  // Clear from usual storage
  localStorage.removeItem('userId');
  sessionStorage.removeItem('userId');
  localStorage.removeItem('customerId');
  sessionStorage.removeItem('customerId');
  localStorage.removeItem('vendorId');
  sessionStorage.removeItem('vendorId');
  
  // Clear from service worker
  storeUserIdInServiceWorker(null);
} */
